import type { ReactNode } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";
import { useUI } from "@/context/UIContext";
import { useAppVersion } from "@/hooks/useAppVersion";

interface AppShellProps {
  children?: ReactNode;
}

export function AppShell({ children }: AppShellProps) {
  const { isMobile, drawerOpen, closeDrawer } = useUI();
  const outdated = useAppVersion();
  const showStaticSidebar = !isMobile;
  return (
    <div className="flex h-screen w-screen overflow-hidden bg-bg text-text">
      {showStaticSidebar && <Sidebar />}

      {isMobile && drawerOpen && (
        <>
          <div
            onClick={closeDrawer}
            className="fixed inset-0 bg-text/40 z-30"
            aria-hidden
          />
          <Sidebar onCloseDrawer={closeDrawer} mobile />
        </>
      )}

      <div className="flex-1 min-w-0 flex flex-col">
        <Topbar />
        {outdated && (
          <div className="bg-warning-soft text-text-2 px-4 py-2 text-xs border-b border-warning/40">
            Hay una nueva versión disponible.{" "}
            <button onClick={() => window.location.reload()} className="underline font-medium text-text">
              Recargar
            </button>
          </div>
        )}
        <main className="flex-1 min-w-0 overflow-auto">
          {children ?? <Outlet />}
        </main>
      </div>
    </div>
  );
}
